import { FC } from 'react';

/** @deprecated */
const ExitLinkIcon: FC = () => (
  <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.8326 9.23161V22.2863H0.832642V8.29913H5.83264"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.8326 0.839355L23.8326 4.56924L19.8326 8.29913"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.8326 4.56921H14.3326C11.2956 4.56921 8.83264 6.86593 8.83264 9.69789V11.0966"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ExitLinkIcon;
